<div class="chip" [class.selected]="selected" [class.disabled]="disabled">
  <ng-content></ng-content>
  <ng-container *ngIf="dismissable">
    <ng-container *ngIf="disabled; else enabled">
      <img src="assets/icons/grey/X.svg" alt="" height="16" width="16" [style.height.rem]="1" [style.width.rem]="1" />
    </ng-container>
    <ng-template #enabled>
      <img
        *ngIf="selected"
        src="assets/icons/primary/X.svg"
        alt=""
        height="16"
        width="16"
        [style.height.rem]="1"
        [style.width.rem]="1" />
      <img
        *ngIf="!selected"
        src="assets/icons/dark/X.svg"
        alt=""
        height="16"
        width="16"
        [style.height.rem]="1"
        [style.width.rem]="1" />
    </ng-template>
  </ng-container>
</div>
